import React from "react";
import { formatValue } from "@/utils";
import { LucideProps } from "lucide-react";


interface FinanceCardProps {
  icon: React.ComponentType<LucideProps>;
  iconBgColor: string;
  iconTextColor: string;
  label: string;
  realizedValue: number;
  projectedValue?: number;
}

export const FinanceCard: React.FC<FinanceCardProps> = ({
  icon: Icon,
  iconBgColor,
  iconTextColor,
  label,
  realizedValue,
  projectedValue,
}) => {
  return (
    <div
      className={`px-5 ${
        typeof projectedValue === "undefined" ? "py-7" : "py-4"
      } rounded-xl border border-zinc-200/50 shadow-xl shadow-zinc-200/50 flex items-center gap-4`}
    >
      <div className={`p-2.5 rounded ${iconBgColor} ${iconTextColor}`}>
        <Icon size={16} />
      </div>
      <div className="flex flex-col gap-3 text-zinc-500">
        <p className="text-sm font-medium">{label}</p>
        <h3 className="font-bold text-2xl text-zinc-700">
          {formatValue(realizedValue)}
        </h3>
        {typeof projectedValue !== "undefined" && (
          <p className="text-base font-medium">
            Em aberto: {formatValue(Number(projectedValue))}
          </p>
        )}
      </div>
    </div>
  );
};
